export default "__VITE_ASSET__CzQzlNlo__"